import styled from 'styled-components';

export default styled.h4`
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/modules/common/DetailsHeading.js